/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import { PUBLIC_COLORS } from "assets/theme/publicTokens";

function PublicFooter() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { name: "Gizlilik Politikası", path: "/privacy-policy" },
      { name: "Kullanım Şartları", path: "/terms-of-service" },
      { name: "KVKK Aydınlatma Metni", path: "/kvkk" },
      { name: "Çerez Politikası", path: "/cookie-policy" },
    ],
    quickLinks: [
      { name: "Hakkımızda", path: "/hakkimizda" },
      { name: "Blog", path: "/blog" },
      { name: "İlanlar", path: "/ilanlar" },
      { name: "Emlak Ofisleri", path: "/emlak-ofisleri" },
      { name: "Emlak Ofisi Başvurusu", path: "/emlak-ofisi-basvuru" },
      { name: "Emlak Ofisi Girişi", path: "/emlak-ofisi-girisi" },
    ],
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: PUBLIC_COLORS.navy,
        color: "white",
        py: 6,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" mb={2}>
              <Box
                component="img"
                src={require("assets/images/renix-logo-white-transparent.png")}
                alt="Renix Logo"
                sx={{ width: "40px", height: "40px", mr: 2 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "white !important", opacity: 1, mb: 2, lineHeight: 1.7 }}
            >
              RENIX GRUP EMLAK INSAAT YAZILIM TURIZM SITE YONETIMI SANAYI TICARET LIMITED SIRKETI
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "white !important",
                opacity: 0.8,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <EmailIcon fontSize="small" />
              info@renix.app
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" fontWeight="bold" color="white !important" mb={2}>
              Hızlı Bağlantılar
            </Typography>
            {footerLinks.quickLinks.map((link) => (
              <Link
                key={link.name}
                onClick={() => navigate(link.path)}
                sx={{
                  display: "block",
                  color: "white !important",
                  opacity: 0.8,
                  textDecoration: "none",
                  mb: 1,
                  cursor: "pointer",
                  transition: "all 0.3s",
                  "&:hover": {
                    opacity: 1,
                    paddingLeft: "8px",
                  },
                }}
              >
                {link.name}
              </Link>
            ))}
          </Grid>

          {/* Legal */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" fontWeight="bold" color="white !important" opacity={1} mb={2}>
              Yasal
            </Typography>
            {footerLinks.legal.map((link) => (
              <Link
                key={link.name}
                onClick={() => navigate(link.path)}
                sx={{
                  display: "block",
                  color: "white !important",
                  opacity: 0.8,
                  textDecoration: "none",
                  mb: 1,
                  cursor: "pointer",
                  transition: "all 0.3s",
                  "&:hover": {
                    opacity: 1,
                    paddingLeft: "8px",
                  },
                }}
              >
                {link.name}
              </Link>
            ))}
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255, 255, 255, 0.1)" }} />

        {/* Bottom Section */}
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <Typography variant="body2" sx={{ color: "white !important", opacity: 0.8 }}>
            © {currentYear} Renix. Tüm hakları saklıdır.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default PublicFooter;
